import React, { useMemo } from 'react';
import { groupTasksByCampaign } from '../utils/groupTasksByCampaign';
import { MissionsSection } from './MissionsSection';
import CampaignDivider from './CampaignDivider';
import ActiveMissionItem from './ActiveMissionItem';
import BlockedMissionItem from './BlockedMissionItem';

/**
 * Blocked missions are shown with a warning icon and red styling.
 * In multi-campaign mode, missions are grouped by campaign with dividers.
 */
export const ActiveMissionsList = ({
  tasks,
  blockedTasks = [],
  isCollapsed,
  onToggle,
  onGoToTask,
  onMissionHover,
  onMissionLeave,
  isMultiCampaignMode = false,
}) => {
  const allTasks = useMemo(() => {
    const markedBlocked = blockedTasks.map((t) => ({ ...t, _isBlocked: true }));
    const markedActive = tasks.map((t) => ({ ...t, _isBlocked: false }));
    return [...markedBlocked, ...markedActive];
  }, [tasks, blockedTasks]);

  const groupedTasks = useMemo(() => {
    if (!isMultiCampaignMode) return null;
    return groupTasksByCampaign(allTasks);
  }, [allTasks, isMultiCampaignMode]);

  const renderTask = (task) => {
    // List hover fill is pure CSS (:hover). These only sync the canvas card.
    const hoverProps = {
      onGoToTask,
      onMouseEnter: () => onMissionHover?.(task.id),
      onMouseLeave: () => onMissionLeave?.(),
    };

    return task._isBlocked ? (
      <BlockedMissionItem key={task.id} task={task} {...hoverProps} />
    ) : (
      <ActiveMissionItem key={task.id} task={task} {...hoverProps} />
    );
  };

  return (
    <MissionsSection
      title="ACTIVE MISSIONS"
      count={tasks.length + blockedTasks.length}
      isCollapsed={isCollapsed}
      onToggle={onToggle}
      isActive
    >
      {isMultiCampaignMode && groupedTasks ? (
        groupedTasks.map(({ campaign, tasks: groupTasks }) => (
          <React.Fragment key={campaign.id}>
            <CampaignDivider campaign={campaign} />
            {groupTasks.map(renderTask)}
          </React.Fragment>
        ))
      ) : (
        <>
          {blockedTasks.map((task) => renderTask({ ...task, _isBlocked: true }))}
          {tasks.map((task) => renderTask({ ...task, _isBlocked: false }))}
        </>
      )}
    </MissionsSection>
  );
};
